var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1238_820)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 18,
    fill: "#FF0038"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8971 16.0538L15.9697 15.9697C16.2359 15.7034 16.6526 15.6792 16.9462 15.8971L17.0303 15.9697L22 20.939L26.9697 15.9697C27.2359 15.7034 27.6526 15.6792 27.9462 15.8971L28.0303 15.9697C28.2966 16.2359 28.3208 16.6526 28.1029 16.9462L28.0303 17.0303L23.061 22L28.0303 26.9697C28.2966 27.2359 28.3208 27.6526 28.1029 27.9462L28.0303 28.0303C27.7641 28.2966 27.3474 28.3208 27.0538 28.1029L26.9697 28.0303L22 23.061L17.0303 28.0303C16.7641 28.2966 16.3474 28.3208 16.0538 28.1029L15.9697 28.0303C15.7034 27.7641 15.6792 27.3474 15.8971 27.0538L15.9697 26.9697L20.939 22L15.9697 17.0303C15.7034 16.7641 15.6792 16.3474 15.8971 16.0538L15.9697 15.9697L15.8971 16.0538Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1238_820",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1238_820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1238_820",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconRed);
export default __webpack_public_path__ + "static/media/close-icon-red.066505dc55fb9d32dd69921a61272b66.svg";
export { ForwardRef as ReactComponent };